export const tenantTypes = {
    GET_TENANT_INFO: "GET_TENANT_INFO",
    TENANT_INFO_ERROR: "TENANT_INFO_ERROR"
}